import axios from "axios";
import url from "../config/urlServiceConfig";

const notificationAPI = {
  getAll: () => axios.get(url.notification),
  getAllConfig: () => axios.get(`${url.notificationConf}`),
  getConfigById: id => axios.get(`${url.notificationConf}/${id}`),
  updateConfig: body => axios.put(`${url.notificationConf}`, body),
  updateNotification: id => axios.put(`${url.notification}/${id}`)
};

export default notificationAPI;
